const ostat = new Map([
  [1, 'New'],
  [10, 'Schedule-Intake'],
  [20, 'Picked-up'],
  [30, 'Checked-in'],
  [40, 'Processing'],
  [50, 'Schedule-Return'],
  [100, 'Completed'],
  [199, 'Cancelled'],
])

export default ostat;
